import { useUserData } from "./useUserData";

export const useIsAllowedAgromanagerUser = () => {
  const { isAgromanagerUser } = useUserData();
  return isAgromanagerUser;
};
